import Swal from 'sweetalert2'

export const userKey = '_Sollicita.SollAI'
export const rememberKey = '_Sollicita.SollAI_remember'
export const navegacaoKey = '_SollAI.Navegacao'

export var urlApi = process.env.VUE_APP_URL_API
export var urlApiSollicita = process.env.VUE_APP_URL_API_SOLLICITA
export var idModulo = 41
export var urlPortal = process.env.VUE_APP_URL_PORTAL
export var urlSignal = process.env.VUE_APP_URL_SIGNAL
export var urlSite = 'https://sollai.com.br/';
export var msgManutencao = false;
export var urlSuporte = process.env.VUE_APP_URL_SUPORTE
export var limiteSubMensagens = 5;
export var urlOnlyoffice = 'https://onlyoffice.sollicita.com.br/web-apps/apps/api/documents/api.js';

export function applyAuthToStore(store, data) {
    if (!data || !data.token) return;

    data.token.usuario = data.usuario;
    data.token.usuario.idContrato = data.idContrato;
    data.token.usuario.tpPessoa = data.tpPessoa;
    data.token.usuario.flCortesia = data.flCortesia;
    data.token.usuario.isAdmContrato = data.isAdmContrato;
    data.token.usuario.isAdmin = data.isAdmin;

    store.commit('setUser', data.token);
    store.commit('setDtFimContrato', data.dtFimContrato);
}

export function avisoErro(e) {
    if (e && e.response && e.response.data) {
        //alert(e.response.data);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e.response.data,
        })
    } else if (typeof e === 'string') {
        //alert(e);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    } else {
        //alert('Erro');
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    }
}

export function avisoSucesso(msg) {
    Swal.fire({
        icon: 'success',
        title: 'Sucesso',
        text: msg,
    })
}

export function avisoToast(msg, icon = 'success') {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    Toast.fire({
        icon: icon,
        title: msg
    })
}

export function onlyCNPJChars(value) {
    return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
}

export function formatCnpjInput(value) {
    const chars = onlyCNPJChars(value)
    // 12 primeiros: alfanum�ricos. 2 �ltimos (DV): somente d�gitos.
    const base = chars.slice(0, 12)
    const dv = chars.slice(12).replace(/\D/g, '').slice(0, 2)
    const raw = base + dv
    if (!raw) return ''

    let formatted = raw.slice(0, 2)
    if (raw.length > 2) formatted += '.' + raw.slice(2, 5)
    if (raw.length > 5) formatted += '.' + raw.slice(5, 8)
    if (raw.length > 8) formatted += '/' + raw.slice(8, 12)
    if (raw.length > 12) formatted += '-' + raw.slice(12, 14)
    return formatted
}

function valorCNPJChar(char) {
    return char.charCodeAt(0) - 48
}

function calcularDVCNPJAlfanumerico(base) {
    let soma = 0
    let peso = base.length - 7

    for (let i = 0; i < base.length; i++) {
        soma += valorCNPJChar(base[i]) * peso
        peso--
        if (peso < 2) {
            peso = 9
        }
    }

    const resto = soma % 11
    return resto === 0 || resto === 1 ? 0 : 11 - resto
}

/** Valida��o num�rica cl�ssica (14 d�gitos). */
export function cnpjValidationNumerico(value) {
    if (!value) return false

    const isString = typeof value === 'string'
    const validTypes = isString || Number.isInteger(value) || Array.isArray(value)
    if (!validTypes) return false

    if (isString) {
        if (value.length > 18) return false

        const digitsOnly = /^\d{14}$/.test(value)
        const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value)
        if (!digitsOnly && !validFormat) return false
    }

    const match = value.toString().match(/\d/g)
    const numbers = Array.isArray(match) ? match.map(Number) : []
    if (numbers.length !== 14) return false

    const items = [...new Set(numbers)]
    if (items.length === 1) return false

    const calc = (x) => {
        const slice = numbers.slice(0, x)
        let factor = x - 7
        let sum = 0

        for (let i = x; i >= 1; i--) {
            const n = slice[x - i]
            sum += n * factor--
            if (factor < 2) factor = 9
        }

        const result = 11 - (sum % 11)
        return result > 9 ? 0 : result
    }

    const digits = numbers.slice(12)
    const digit0 = calc(12)
    if (digit0 !== digits[0]) return false

    const digit1 = calc(13)
    return digit1 === digits[1]
}

/** Valida��o alfanum�rica (12 alfanum�ricos + 2 d�gitos verificadores). */
export function cnpjValidationAlfanumerico(cnpj) {
    const c = onlyCNPJChars(cnpj)

    if (!/^[A-Z0-9]{12}\d{2}$/.test(c)) return false
    if (/^(\d)\1{13}$/.test(c)) return false

    const base = c.slice(0, 12)
    const dvInformado = c.slice(12)
    const dv1 = calcularDVCNPJAlfanumerico(base)
    const dv2 = calcularDVCNPJAlfanumerico(base + dv1)

    return dvInformado === `${dv1}${dv2}`
}

export function cnpjValidation(value) {
    return cnpjValidationNumerico(value) || cnpjValidationAlfanumerico(value)
}

export default {
    userKey,
    rememberKey,
    urlApi,
    avisoErro,
    avisoSucesso,
    urlApiSollicita,
    avisoToast,
    applyAuthToStore,
    idModulo,
    urlPortal,
    urlSignal,
    urlSite,
    msgManutencao,
    urlSuporte,
    navegacaoKey,
    limiteSubMensagens,
    urlOnlyoffice,
    cnpjValidation,
    cnpjValidationNumerico,
    cnpjValidationAlfanumerico,
    formatCnpjInput,
}